import timings from "../assets/dataSala/tiempoAnimacion.json";

// Versión de las animaciones de sorteo por sala. Un mismo filtro decide el Hot Seat y el sorteo virtual:
//   "3d"  -> la animación 3D (más pesada; solo en las salas que la tengan habilitada)
//   "2d"  -> la liviana (por defecto): canvas 2D en Hot Seat y la ánfora clásica en el sorteo virtual
// Se habilita agregando "animation": "3d" a la sala en src/assets/dataSala/tiempoAnimacion.json.
export function animationVersion(salaId) {
  return timings.find((entry) => Number(entry.salaId) === Number(salaId))?.animation === "3d" ? "3d" : "2d";
}

// ?animation=3d o ?animation=2d fuerza una versión para probar sin tocar la configuración.
export function forcedAnimation() {
  const forced = new URLSearchParams(window.location.search).get("animation");
  return forced === "3d" || forced === "2d" ? forced : null;
}
